import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Tooltip from '@material-ui/core/Tooltip';
import FlagIcon from '@material-ui/icons/Flag';
import classNames from 'classnames/bind';

import { translate } from 'services/i18nService';
import NotificationService from 'services/NotificationService';
import ProfileService from 'services/ProfileService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';

import styles from './MarkAsSpam.css';


const cx = classNames.bind(styles);

function MarkAsSpam(props) {
  const { msg } = props;

  const [active, setActive] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  const onClick = useCallback(() => {
    if (!active) {
      setDisabled(true);
      ProfileService.markAsSpamMessage({
        recipient: msg.senderOriginalUsername,
        type: 'markAsSpam',
        reason: msg.message,
        accessHash: UserStore.user.accessHash,
        username: UserStore.user.username,
        roomname: ProfileStore.profileName,
      })
        .then((response) => {
          if (response.data.status === 'ok') {
            setActive(true);
          } else {
            throw Error();
          }
        })
        .catch(() => {
          setDisabled(false);
          NotificationService.create({
            type: NotificationService.type.TOAST,
            text: translate('v2profile.notification.error.default'),
            subtype: NotificationService.subtype.ERROR,
          });
        });
    }
  }, [
    active,
    msg.message,
    msg.senderOriginalUsername,
  ]);

  return (
    <button
      className={cx('btn')}
      disabled={active || disabled}
      onClick={onClick}
    >
      <Tooltip
        classes={{ popper: cx('tooltip') }}
        placement="left"
        title={translate('strings.markAsSpam.tooltip')}
      >
        <FlagIcon className={cx('icon', { 'icon--active': active })} />
      </Tooltip>
    </button>
  );
}

MarkAsSpam.propTypes = { msg: PropTypes.object.isRequired };

export default observer(MarkAsSpam);
